// controllers
import { ArController, gameDispatcher } from '@aceroll/core';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

// constants
import { GAME_TYPE, GAME_VIEW } from "../../constants/game";

// services
import { autoplayService } from '../../services/autoplay-service';
import { gameSoundService } from '../../services/game-sound-service';

export class EvFeatureExit extends ArController {
	async onStart() {
		const serverEvent = responseService.getEvent();
		console.log('serverEvent', serverEvent);

		const featureExitPopup = this.context.currentLayout.featureExitPopup;
		const totalWinAmount = serverEvent.totalWin;

		gameSoundService.fadeOutCurrentAmbient(1000);

		let autoProceed = false;
		if (autoplayService.started && !autoplayService.stopAutoplayOnFeature) {
			autoProceed = true;
		}
		gameSoundService.setBonusSplashAmbient(500);
		platform.setFeatureExit();
		await featureExitPopup.show(totalWinAmount || 0, autoProceed);

		gameDispatcher.setState({
			gameType: GAME_TYPE.DEFAULT,
			gameView: GAME_VIEW.MAIN
		});

		// drop the health bar to 0.
		const { healthBar } = this.context.currentLayout;
		healthBar.setHealth(0);

		await featureExitPopup.hide();

		responseService.completeEvent();
		this.stop();
	}

	onStop() {
		gameSoundService.setBaseAmbient(1000);
		responseService.currentFeature = null;
	}
}
